module.exports = __webpack_public_path__ + "img/news-date.bf1d65b5.svg";